(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dnh-community"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-dnh-community]').forEach((section)=>{if(section.dataset.sliderReady)return;section.dataset.sliderReady='true';const track=section.querySelector('.dnh-community__track');const cards=[...track.querySelectorAll('article')];const dots=[...section.querySelectorAll('.dnh-community__controls i')];let index=0;const go=(next)=>{index=(next+cards.length)%cards.length;track.scrollTo({left:cards[index].offsetLeft-track.offsetLeft,behavior:'smooth'});dots.forEach((dot,i)=>dot.classList.toggle('is-active',i===index%dots.length));};section.querySelector('[data-community-prev]').addEventListener('click',()=>go(index-1));section.querySelector('[data-community-next]').addEventListener('click',()=>go(index+1));cards.forEach((card)=>{const video=card.querySelector('video');const button=card.querySelector('button');button.addEventListener('click',()=>{section.querySelectorAll('video').forEach((other)=>{if(other!==video)other.pause();});if(video.paused){video.play();card.classList.add('is-playing');}else{video.pause();card.classList.remove('is-playing');}});video.addEventListener('click',()=>button.click());video.addEventListener('pause',()=>card.classList.remove('is-playing'));});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dnh-faq-page"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-dnh-faq-page]').forEach((section) => {
    if (section.dataset.dnhFaqReady === 'true') return;
    section.dataset.dnhFaqReady = 'true';

    const search = section.querySelector('[data-dnh-faq-search]');
    const clear = section.querySelector('[data-dnh-faq-clear]');
    const categories = section.querySelector('[data-dnh-categories]');
    const categoryButtons = [...section.querySelectorAll('[data-dnh-category]')];
    const results = section.querySelector('[data-dnh-faq-results]');
    const resultsHeading = section.querySelector('[data-dnh-results-heading]');
    const items = [...section.querySelectorAll('[data-dnh-faq-item]')];
    const empty = section.querySelector('[data-dnh-faq-empty]');
    const showAll = section.querySelector('[data-dnh-show-all]');
    const initialHeading = resultsHeading?.textContent || 'Frequently Asked Questions';
    const showInitially = section.dataset.showInitial === 'true';
    let activeCategory = '';

    const revealResults = () => {
      results.hidden = false;
    };

    const filterItems = ({ query = '', category = '' } = {}) => {
      const cleanQuery = query.trim().toLowerCase();
      let visibleCount = 0;

      items.forEach((item) => {
        const matchesSearch = !cleanQuery || item.dataset.search.includes(cleanQuery);
        const matchesCategory = !category || item.dataset.category === category;
        const visible = matchesSearch && matchesCategory;
        item.hidden = !visible;
        if (!visible) item.open = false;
        if (visible) visibleCount += 1;
      });

      empty.hidden = visibleCount !== 0;
      return visibleCount;
    };

    const activateCategory = (button, shouldScroll = true) => {
      activeCategory = button.dataset.dnhCategory;
      categoryButtons.forEach((item) => item.classList.toggle('is-active', item === button));
      resultsHeading.textContent = button.dataset.dnhCategoryTitle;
      revealResults();
      filterItems({ category: activeCategory });
      if (search) search.value = '';
      if (clear) clear.hidden = true;
      if (shouldScroll) results.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    categoryButtons.forEach((button) => {
      button.addEventListener('click', () => activateCategory(button));
    });

    section.querySelectorAll('[data-dnh-view]').forEach((button) => {
      button.addEventListener('click', () => {
        const listView = button.dataset.dnhView === 'list';
        categories.classList.toggle('is-list', listView);
        section.querySelectorAll('[data-dnh-view]').forEach((control) => {
          const active = control === button;
          control.classList.toggle('is-active', active);
          control.setAttribute('aria-pressed', String(active));
        });
      });
    });

    search?.addEventListener('input', () => {
      const query = search.value.trim();
      clear.hidden = query.length === 0;
      categoryButtons.forEach((button) => button.classList.remove('is-active'));

      if (query) {
        activeCategory = '';
        resultsHeading.textContent = 'Search results';
        revealResults();
        filterItems({ query });
      } else if (activeCategory) {
        filterItems({ category: activeCategory });
      } else if (showInitially) {
        resultsHeading.textContent = initialHeading;
        revealResults();
        filterItems();
      } else {
        results.hidden = true;
      }
    });

    clear?.addEventListener('click', () => {
      search.value = '';
      clear.hidden = true;
      search.focus();
      if (showInitially) {
        resultsHeading.textContent = initialHeading;
        revealResults();
        filterItems();
      } else {
        results.hidden = true;
      }
    });

    showAll?.addEventListener('click', () => {
      activeCategory = '';
      categoryButtons.forEach((button) => button.classList.remove('is-active'));
      resultsHeading.textContent = initialHeading;
      revealResults();
      filterItems();
    });

    if (showInitially) filterItems();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dnh-flavor-builder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dnh-flavor-builder')) {
    customElements.define('dnh-flavor-builder', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.dnhReady === 'true') return;
        this.dataset.dnhReady = 'true';
        this.purchase = this.dataset.hasSellingPlan === 'true' ? 'subscription' : 'onetime';
        this.dataset.purchase = this.purchase;
        this.panel = this.querySelector('.dnh-flavors__panel');
        this.labelModal = this.querySelector('[data-label-modal]');
        this.labelContent = this.querySelector('[data-label-content]');
        this.querySelectorAll('[data-purchase]').forEach((button) => {
          const active = button.dataset.purchase === this.purchase;
          button.classList.toggle('is-active', active);
          if (button.dataset.purchase === 'subscription' && this.dataset.hasSellingPlan !== 'true') {
            button.disabled = true;
            button.setAttribute('aria-disabled', 'true');
          }
        });
        window.addEventListener('dnh:open-flavors', (event) => this.open(event.detail?.purchase));
        this.querySelector('[data-dnh-close-flavors]')?.addEventListener('click', () => this.close());
        this.addEventListener('click', (event) => {
          if (event.target === this) this.close();
        });
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.labelModal?.open) return;
          if (event.key === 'Escape' && this.classList.contains('is-open')) this.close();
        });
        this.querySelectorAll('[data-label-open]').forEach((button) => button.addEventListener('click', () => this.openLabel(button)));
        this.querySelector('[data-label-close]')?.addEventListener('click', () => this.closeLabel());
        this.labelModal?.addEventListener('click', (event) => {
          if (event.target === this.labelModal) this.closeLabel();
        });
        this.labelModal?.addEventListener('close', () => this.labelReturnFocus?.focus());
        this.querySelectorAll('[data-purchase]').forEach((button) => button.addEventListener('click', () => {
          if (button.disabled) return;
          this.setPurchase(button.dataset.purchase);
        }));
        this.querySelectorAll('.dnh-flavor').forEach((card) => {
          card.querySelector('[data-minus]').addEventListener('click', () => this.change(card, -1));
          card.querySelector('[data-plus]').addEventListener('click', () => this.change(card, 1));
        });
        this.querySelector('[data-submit]').addEventListener('click', () => this.submit());
        this.update();
      }
      setPurchase(purchase) {
        this.purchase = purchase === 'subscription' && this.dataset.hasSellingPlan !== 'true' ? 'onetime' : purchase;
        this.dataset.purchase = this.purchase;
        this.querySelectorAll('[data-purchase]').forEach((item) => {
          item.classList.toggle('is-active', item.dataset.purchase === this.purchase);
        });
        this.update();
      }
      open(purchase) {
        if (purchase) this.setPurchase(purchase);
        this.classList.add('is-open');
        this.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('dnh-flavors-lock');
        this.panel?.focus();
      }
      close() {
        this.closeLabel();
        this.classList.remove('is-open');
        this.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('dnh-flavors-lock');
      }
      openLabel(button) {
        const template = button.closest('.dnh-flavor__body')?.querySelector('[data-label-template]');
        if (!this.labelModal || !this.labelContent || !template) return;
        this.labelContent.replaceChildren(template.content.cloneNode(true));
        const title = this.labelModal.querySelector('[data-label-title]');
        if (title) title.textContent = button.dataset.labelTitle || 'Product label';
        this.labelReturnFocus = button;
        if (!this.labelModal.open) this.labelModal.showModal();
      }
      closeLabel() {
        if (this.labelModal?.open) this.labelModal.close();
      }
      async getCart() {
        const response = await fetch(this.dataset.cartJsonUrl, { headers: { 'Accept': 'application/json' } });
        if (!response.ok) throw new Error('Cart request failed');
        return response.json();
      }
      async changeCartLine(key, quantity) {
        const response = await fetch(this.dataset.cartChangeUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity })
        });
        if (!response.ok) throw new Error('Cart update failed');
      }
      async reconcileSubscriptionGift() {
        const cart = await this.getCart();
        const giftLines = cart.items.filter((item) => item.properties?._dnh_subscription_gift === 'true');
        const builderProductId = Number(this.dataset.productId);
        const hasSubscription = cart.items.some((item) => item.selling_plan_allocation
          && item.properties?._dnh_subscription_gift !== 'true'
          && (!builderProductId || item.product_id === builderProductId));
        if (!hasSubscription) {
          for (const giftLine of giftLines) await this.changeCartLine(giftLine.key, 0);
          return false;
        }
        if (!giftLines.length && Number(this.dataset.giftVariant)) {
          const response = await fetch(this.dataset.cartUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{
              id: Number(this.dataset.giftVariant),
              quantity: 1,
              properties: {
                '_dnh_subscription_gift': 'true',
                'Gift': 'FREE Water Bottle with Subscription'
              }
            }] })
          });
          if (!response.ok) throw new Error('Gift request failed');
          return true;
        }
        for (let index = 0; index < giftLines.length; index += 1) {
          const requiredQuantity = index === 0 ? 1 : 0;
          if (giftLines[index].quantity !== requiredQuantity) await this.changeCartLine(giftLines[index].key, requiredQuantity);
        }
        return true;
      }
      change(card, delta) {
        const output = card.querySelector('output');
        output.textContent = Math.max(0, Number(output.textContent) + delta);
        card.classList.toggle('is-selected', Number(output.textContent) > 0);
        this.update();
      }
      update() {
        const count = [...this.querySelectorAll('output')].reduce((sum, item) => sum + Number(item.textContent), 0);
        const subscriptionPrice = Number(this.dataset.subscriptionPrice);
        const total = [...this.querySelectorAll('.dnh-flavor')].reduce((sum, card) => {
          const oneTimePrice = Math.round(Number(card.dataset.price) * 0.7);
          const unitPrice = this.purchase === 'subscription' && subscriptionPrice > 0 ? subscriptionPrice : oneTimePrice;
          return sum + (unitPrice * Number(card.querySelector('output').textContent));
        }, 0);
        this.querySelector('[data-count]').textContent = count;
        this.querySelector('[data-total]').textContent = new Intl.NumberFormat('en-AE', { style: 'currency', currency: 'AED', currencyDisplay: 'code' }).format(total / 100).replace(/\s+/g, ' ');
        this.querySelector('[data-submit]').disabled = count === 0;
      }
      async submit() {
        const button = this.querySelector('[data-submit]');
        const status = this.querySelector('[data-status]');
        const sellingPlan = this.querySelector('[data-delivery]')?.value || this.dataset.sellingPlan;
        const delivery = this.querySelector('[data-delivery] option:checked')?.textContent?.trim() || '';
        const isSubscription = this.purchase === 'subscription' && Boolean(sellingPlan);
        const items = [...this.querySelectorAll('.dnh-flavor')].map((card) => {
          const quantity = Number(card.querySelector('output').textContent);
          const item = {
            id: Number(card.dataset.variantId),
            quantity,
            properties: {
              'Purchase type': isSubscription ? 'Subscribe and save' : 'One time'
            }
          };
          if (isSubscription && delivery) item.properties.Delivery = delivery;
          if (isSubscription) item.selling_plan = Number(sellingPlan);
          return item;
        }).filter((item) => item.quantity > 0);
        if (!items.length) return;
        button.disabled = true; status.textContent = 'Adding your flavors...';
        try {
          const response = await fetch(this.dataset.cartUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items }) });
          if (!response.ok) throw new Error('Cart request failed');
          const cartHasSubscription = await this.reconcileSubscriptionGift();
          window.location.href = '/checkout';
        } catch (error) {
          status.textContent = 'Something went wrong. Please try again.'; button.disabled = false;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dnh-header"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-dnh-header]').forEach((header) => {
    if (header.dataset.ready === 'true') return;
    header.dataset.ready = 'true';
    const setHeight = () => document.documentElement.style.setProperty('--dnh-site-header-height', `${header.offsetHeight}px`);
    setHeight();
    window.addEventListener('resize', setHeight, { passive: true });
    const trigger = header.querySelector('.dnh-site-header__menu-button');
    const dialog = header.querySelector('.dnh-menu');
    const closes = header.querySelectorAll('.dnh-menu__close,.dnh-menu__backdrop');
    const close = () => { dialog.close(); trigger.setAttribute('aria-expanded','false'); trigger.focus(); };
    trigger.addEventListener('click', () => { dialog.showModal(); trigger.setAttribute('aria-expanded','true'); dialog.querySelector('.dnh-menu__close').focus(); });
    closes.forEach((button) => button.addEventListener('click', close));
    dialog.addEventListener('cancel', (event) => { event.preventDefault(); close(); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dnh-ingredients"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-dnh-ingredients]').forEach((section) => {if(section.dataset.ready)return;section.dataset.ready='true';const tabs=[...section.querySelectorAll('[role=tab]')];tabs.forEach((tab)=>tab.addEventListener('click',()=>{tabs.forEach((item)=>{const active=item===tab;item.setAttribute('aria-selected',active);section.querySelector('#'+item.getAttribute('aria-controls')).hidden=!active;});}));const dialog=section.querySelector('.dnh-label-dialog');section.querySelector('.dnh-label-open')?.addEventListener('click',()=>dialog.showModal());section.querySelector('.dnh-label-close')?.addEventListener('click',()=>dialog.close());dialog?.addEventListener('click',(event)=>{if(event.target===dialog)dialog.close();});});
  document.querySelectorAll('.dnh-label-dialog').forEach((dialog) => {
    if (dialog.dataset.zoomReady) return;
    dialog.dataset.zoomReady = 'true';
    const image = dialog.querySelector('.dnh-label-viewport img');
    const viewport = dialog.querySelector('.dnh-label-viewport');
    if (!image || !viewport) return;
    const setZoom = (zoomed) => {
      dialog.classList.toggle('is-zoomed', zoomed);
      image.setAttribute('aria-pressed', String(zoomed));
      image.setAttribute('aria-label', zoomed ? 'Zoom out nutrition label' : 'Zoom in nutrition label');
      if (!zoomed) viewport.scrollTo(0, 0);
    };
    image.addEventListener('click', () => setZoom(!dialog.classList.contains('is-zoomed')));
    image.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        setZoom(!dialog.classList.contains('is-zoomed'));
      }
    });
    dialog.addEventListener('close', () => setZoom(false));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dnh-join-community-application"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-dnh-community-application]').forEach((section) => {
    if (section.dataset.ready === 'true') return;
    section.dataset.ready = 'true';

    // Make only "NOW" bold anywhere NOWHYDRATE appears in visible section text.
    const boldNowInText = (root) => {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      const textNodes = [];
      while (walker.nextNode()) {
        const node = walker.currentNode;
        if (
          /NOWHYDRATE/i.test(node.nodeValue || '') &&
          !node.parentElement.closest('script, style, textarea, input, select, option')
        ) {
          textNodes.push(node);
        }
      }

      textNodes.forEach((node) => {
        const parts = node.nodeValue.split(/(NOWHYDRATE)/gi);
        const fragment = document.createDocumentFragment();

        parts.forEach((part) => {
          if (/^NOWHYDRATE$/i.test(part)) {
            const now = document.createElement('strong');
            now.className = 'dnh-now-bold';
            now.textContent = part.slice(0, 3);
            fragment.appendChild(now);
            fragment.appendChild(document.createTextNode(part.slice(3)));
          } else if (part) {
            fragment.appendChild(document.createTextNode(part));
          }
        });

        node.replaceWith(fragment);
      });
    };

    boldNowInText(section);
    const slides = [...section.querySelectorAll('[data-community-slide]')];
    const dots = [...section.querySelectorAll('[data-community-dot]')];
    let active = 0;
    const show = (index) => {
      active = index;
      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === active;
        slide.classList.toggle('is-active', isActive);
        const video = slide.querySelector('video');
        if (!video) return;
        if (isActive) video.play().catch(() => {});
        else video.pause();
      });
      dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === active));
    };
    dots.forEach((dot, index) => dot.addEventListener('click', () => show(index)));
    show(0);
    if (slides.length > 1) setInterval(() => show((active + 1) % slides.length), 6000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dnh-product-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.dnh-product-hero').forEach((section) => {
    const image = section.querySelector('.dnh-product-hero__image');
    section.querySelectorAll('[data-dnh-product-thumb]').forEach((button) => {
      button.addEventListener('click', () => {
        if (image) {
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.src = button.dataset.image;
          image.alt = button.dataset.alt;
        }
        section.querySelectorAll('[data-dnh-product-thumb]').forEach((thumb) => thumb.classList.toggle('is-active', thumb === button));
      });
    });
    section.querySelectorAll('[data-dnh-purchase-option]').forEach((button) => {
      button.addEventListener('click', () => {
        section.querySelectorAll('[data-dnh-purchase-option]').forEach((option) => {
          const active = option === button;
          option.classList.toggle('is-active', active);
          option.setAttribute('aria-checked', active ? 'true' : 'false');
        });
      });
    });
    section.querySelector('[data-dnh-open-flavors]')?.addEventListener('click', () => {
      const purchase = section.querySelector('[data-dnh-purchase-option].is-active')?.dataset.dnhPurchaseOption || 'subscription';
      window.dispatchEvent(new CustomEvent('dnh:open-flavors', { detail: { purchase } }));
    });

    const zoomButton = section.querySelector('[data-dnh-product-zoom]');
    const zoomDialog = section.querySelector('[data-dnh-product-zoom-dialog]');
    const zoomImage = section.querySelector('[data-dnh-product-zoom-image]');
    const zoomClose = section.querySelector('[data-dnh-product-zoom-close]');

    zoomButton?.addEventListener('click', () => {
      if (!image || !zoomDialog || !zoomImage) return;
      zoomImage.src = image.currentSrc || image.src;
      zoomImage.alt = image.alt || 'Product image';
      if (typeof zoomDialog.showModal === 'function') zoomDialog.showModal();
      else zoomDialog.setAttribute('open', '');
    });

    zoomClose?.addEventListener('click', () => zoomDialog?.close());
    zoomDialog?.addEventListener('click', (event) => {
      if (event.target === zoomDialog) zoomDialog.close();
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dnh-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializedSections = new WeakSet();

    const initializeSlider = (section) => {
      if (!section || initializedSections.has(section)) return;

      const track = section.querySelector('.dnh-reviews__track');
      const originalCards = track
        ? Array.from(track.querySelectorAll('article'))
        : [];

      if (!track || originalCards.length < 2) return;

      initializedSections.add(section);

      originalCards.forEach((card) => {
        const clone = card.cloneNode(true);
        clone.removeAttribute('id');
        clone.removeAttribute('data-shopify-editor-block');
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });

      const firstClone = track.children[originalCards.length];
      const loopWidth =
        firstClone.offsetLeft - originalCards[0].offsetLeft;

      const reducedMotion = window
        .matchMedia('(prefers-reduced-motion: reduce)')
        .matches;

      const speed = reducedMotion ? 0 : 50;
      let previousTime = 0;
      let animationFrame;
      let paused = false;

      const animate = (currentTime) => {
        if (!previousTime) previousTime = currentTime;

        const elapsed = Math.min(currentTime - previousTime, 50);
        previousTime = currentTime;

        if (!paused && speed > 0) {
          track.scrollLeft += speed * elapsed / 1000;

          if (track.scrollLeft >= loopWidth) {
            track.scrollLeft -= loopWidth;
          }
        }

        animationFrame = window.requestAnimationFrame(animate);
      };

      const moveByCard = (direction) => {
        const cardWidth =
          originalCards[0].getBoundingClientRect().width;

        const gap =
          parseFloat(window.getComputedStyle(track).columnGap) || 0;

        track.scrollBy({
          left: direction * (cardWidth + gap),
          behavior: 'smooth'
        });
      };

      section
        .querySelector('[data-review-prev]')
        ?.addEventListener('click', () => moveByCard(-1));

      section
        .querySelector('[data-review-next]')
        ?.addEventListener('click', () => moveByCard(1));

      const canHover = window
        .matchMedia('(hover: hover) and (pointer: fine)')
        .matches;

      if (canHover) {
        track.addEventListener('mouseenter', () => {
          paused = true;
        });

        track.addEventListener('mouseleave', () => {
          paused = false;
          previousTime = performance.now();
        });
      }

      document.addEventListener('visibilitychange', () => {
        paused = document.hidden;
        previousTime = performance.now();
      });

      animationFrame = window.requestAnimationFrame(animate);

      section.addEventListener(
        'dnh:destroy',
        () => {
          window.cancelAnimationFrame(animationFrame);
        },
        { once: true }
      );
    };

    const initializeAll = (root = document) => {
      if (root.matches?.('[data-dnh-reviews]')) {
        initializeSlider(root);
      }

      root
        .querySelectorAll?.('[data-dnh-reviews]')
        .forEach(initializeSlider);
    };

    initializeAll();

    document.addEventListener('shopify:section:load', (event) => {
      initializeAll(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const section = event.target.matches?.('[data-dnh-reviews]')
        ? event.target
        : event.target.querySelector?.('[data-dnh-reviews]');

      section?.dispatchEvent(new CustomEvent('dnh:destroy'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dnh-science-page-experts-slider"] && !Shopify.designMode) return;
  try {
    
  const initDnhExpertsSlider = (section) => {
    if (section.dataset.dnhExpertsReady === 'true') return;
    section.dataset.dnhExpertsReady = 'true';

    const track = section.querySelector('.dnh-science-page-experts__grid');
    const cards = [...section.querySelectorAll('.dnh-science-page-experts article')];
    const dots = [...section.querySelectorAll('[data-expert-dot]')];
    if (!track || !cards.length || !dots.length) return;

    const showCard = (index, behavior = 'smooth') => {
      if (!cards[index]) return;
      const left = cards[index].offsetLeft - cards[0].offsetLeft;
      track.scrollTo({ left, behavior });
      setActive(index);
    };

    const setActive = (index) => {
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = Number(dot.dataset.expertDot) || 0;
        showCard(index);
      });
    });

    track.addEventListener('scroll', () => {
      window.requestAnimationFrame(() => {
        const center = track.scrollLeft + track.clientWidth / 2;
        let activeIndex = 0;
        let activeDistance = Infinity;
        cards.forEach((card, index) => {
          const cardCenter = card.offsetLeft - cards[0].offsetLeft + card.offsetWidth / 2;
          const distance = Math.abs(center - cardCenter);
          if (distance < activeDistance) {
            activeDistance = distance;
            activeIndex = index;
          }
        });
        setActive(activeIndex);
      });
    }, { passive: true });
  };

  document.querySelectorAll('.dnh-science-page-experts').forEach(initDnhExpertsSlider);

  if (window.Shopify && Shopify.designMode && document.documentElement.dataset.dnhExpertsEditorReady !== 'true') {
    document.documentElement.dataset.dnhExpertsEditorReady = 'true';

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('.dnh-science-page-experts');
      if (section) initDnhExpertsSlider(section);
    });

    document.addEventListener('shopify:block:select', (event) => {
      const card = event.target.closest('.dnh-science-page-experts article');
      const section = event.target.closest('.dnh-science-page-experts');
      if (!card || !section) return;

      const track = section.querySelector('.dnh-science-page-experts__grid');
      const cards = [...section.querySelectorAll('.dnh-science-page-experts article')];
      const dots = [...section.querySelectorAll('[data-expert-dot]')];
      const index = cards.indexOf(card);
      if (!track || index < 0) return;

      const left = card.offsetLeft - cards[0].offsetLeft;
      track.scrollTo({ left, behavior: 'auto' });
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dnh-water-bottle-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.dnh-bottle').forEach((section) => {
    const image = section.querySelector('.dnh-bottle__image');
    section.querySelectorAll('[data-dnh-bottle-thumb]').forEach((button) => {
      button.addEventListener('click', () => {
        if (image) {
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.src = button.dataset.image;
          image.alt = button.dataset.alt;
        }
        section.querySelectorAll('[data-dnh-bottle-thumb]').forEach((thumb) => thumb.classList.toggle('is-active', thumb === button));
      });
    });
    const output = section.querySelector('[data-bottle-qty]');
    section.querySelector('[data-bottle-minus]')?.addEventListener('click', () => {
      output.textContent = Math.max(1, Number(output.textContent) - 1);
    });
    section.querySelector('[data-bottle-plus]')?.addEventListener('click', () => {
      output.textContent = Number(output.textContent) + 1;
    });
    section.querySelector('[data-bottle-add]')?.addEventListener('click', async (event) => {
      const button = event.currentTarget;
      const status = section.querySelector('[data-bottle-status]');
      const wrapper = section.querySelector('[data-variant-id]');
      button.disabled = true;
      status.textContent = 'Adding to cart...';
      try {
        const response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: Number(wrapper.dataset.variantId), quantity: Number(output.textContent) }) });
        if (!response.ok) throw new Error('Cart request failed');
        window.location.href = '/cart';
      } catch (error) {
        status.textContent = 'Something went wrong. Please try again.';
        button.disabled = false;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["electrolytes-better-info"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-better-info]').forEach((section) => {
    const tabs = section.querySelectorAll('[data-panel-target]');
    const panels = section.querySelectorAll('[data-panel]');
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.panelTarget;
        tabs.forEach((item) => {
          const active = item === tab;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach((panel) => panel.classList.toggle('is-active', panel.dataset.panel === target));
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["electrolytes-brand-compare"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-brand-compare-selector]').forEach((selector) => {
    const toggle = selector.querySelector('[data-brand-toggle]');
    const list = selector.querySelector('[data-brand-list]');
    const count = selector.querySelector('[data-brand-count]');
    const section = selector.closest('.dnh-brand-compare');
    const checks = selector.querySelectorAll('[data-brand-check]');
    toggle?.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      list?.classList.toggle('is-open', !expanded);
    });
    checks.forEach((check) => {
      check.addEventListener('change', () => {
        const active = [...checks].filter((item) => item.checked);
        if (active.length === 0) {
          check.checked = true;
          return;
        }
        if (count) count.textContent = active.length;
        checks.forEach((item) => {
          section?.querySelectorAll(`[data-brand-column="${item.value}"]`).forEach((column) => {
            column.classList.toggle('is-hidden', !item.checked);
          });
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["electrolytes-flavour-builder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dnh-flavor-builder')) {
    customElements.define('dnh-flavor-builder', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.dnhReady === 'true') return;
        this.dataset.dnhReady = 'true';
        this.purchase = this.dataset.sellingPlan ? 'subscription' : 'onetime';
        this.targetCount = Number(this.dataset.defaultTarget) || 2;
        this.discount = Number(this.dataset.discount) || 0;
        this.panel = this.querySelector('.dnh-flavors__panel');
        window.addEventListener('dnh:open-flavors', (event) => {
          const requestedPurchase = event.detail?.purchase;
          this.purchase = requestedPurchase === 'subscription' && this.dataset.sellingPlan ? 'subscription' : 'onetime';
          this.querySelectorAll('[data-purchase]').forEach((item) => item.classList.toggle('is-active', item.dataset.purchase === this.purchase));
          this.open();
        });
        this.querySelector('[data-dnh-close-flavors]')?.addEventListener('click', () => this.close());
        this.addEventListener('click', (event) => {
          if (event.target === this) this.close();
        });
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.classList.contains('is-open')) this.close();
        });
        this.querySelectorAll('[data-purchase]').forEach((button) => button.addEventListener('click', () => {
          if (button.dataset.purchase === 'subscription' && !this.dataset.sellingPlan) {
            const status = this.querySelector('[data-status]');
            if (status) status.textContent = 'Subscription selling plan will be connected later. Checkout is set to one-time for now.';
            return;
          }
          this.purchase = button.dataset.purchase;
          this.querySelectorAll('[data-purchase]').forEach((item) => item.classList.toggle('is-active', item === button));
        }));
        this.querySelectorAll('[data-tier]').forEach((button) => button.addEventListener('click', () => {
          this.targetCount = Number(button.dataset.tierQuantity) || 1;
          this.discount = Number(button.dataset.tierDiscount) || 0;
          this.dataset.discount = String(this.discount);
          this.querySelectorAll('[data-tier]').forEach((item) => {
            const active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-checked', active ? 'true' : 'false');
          });
          this.limitToTarget();
          this.update();
        }));
        this.querySelectorAll('[data-delivery]').forEach((button) => button.addEventListener('click', () => {
          this.querySelectorAll('[data-delivery]').forEach((item) => item.classList.toggle('is-active', item === button));
        }));
        this.querySelectorAll('.dnh-flavor').forEach((card) => {
          card.querySelector('[data-minus]')?.addEventListener('click', () => this.change(card, -1));
          card.querySelector('[data-plus]')?.addEventListener('click', () => this.change(card, 1));
        });
        this.querySelector('[data-submit]')?.addEventListener('click', (event) => {
          event.preventDefault();
          this.submit();
        });
        this.update();
      }
      open() {
        this.classList.add('is-open');
        this.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('dnh-flavors-lock');
        this.panel?.focus();
      }
      close() {
        this.classList.remove('is-open');
        this.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('dnh-flavors-lock');
      }
      selectedCount() {
        return [...this.querySelectorAll('output')].reduce((sum, item) => sum + Number(item.textContent), 0);
      }
      change(card, delta) {
        const output = card.querySelector('output');
        const current = Number(output.textContent);
        const selected = this.selectedCount();
        if (delta > 0 && selected >= this.targetCount) return;
        output.textContent = Math.max(0, current + delta);
        card.classList.toggle('is-selected', Number(output.textContent) > 0);
        this.update();
      }
      limitToTarget() {
        let selected = this.selectedCount();
        if (selected <= this.targetCount) return;
        [...this.querySelectorAll('.dnh-flavor')].reverse().forEach((card) => {
          if (selected <= this.targetCount) return;
          const output = card.querySelector('output');
          const quantity = Number(output.textContent);
          if (quantity <= 0) return;
          const remove = Math.min(quantity, selected - this.targetCount);
          output.textContent = quantity - remove;
          card.classList.toggle('is-selected', Number(output.textContent) > 0);
          selected -= remove;
        });
      }
      money(cents) {
        return new Intl.NumberFormat('en-AE', { style: 'currency', currency: 'AED', currencyDisplay: 'code' }).format(cents / 100).replace(/\s+/g, ' ');
      }
      update() {
        const count = this.selectedCount();
        const subtotal = [...this.querySelectorAll('.dnh-flavor')].reduce((sum, card) => sum + (Number(card.dataset.price) * Number(card.querySelector('output').textContent)), 0);
        const discounted = Math.round(subtotal * (100 - this.discount) / 100);
        const remaining = Math.max(0, this.targetCount - count);
        const total = this.querySelector('[data-total]');
        const countEl = this.querySelector('[data-count]');
        const status = this.querySelector('[data-status]');
        const submit = this.querySelector('[data-submit]');
        if (countEl) countEl.textContent = count;
        if (total) total.textContent = this.money(discounted);
        if (submit) submit.disabled = remaining !== 0;
        this.querySelectorAll('[data-plus]').forEach((button) => button.disabled = count >= this.targetCount);
        if (status) {
          if (remaining > 0) status.textContent = `Select ${remaining} more box${remaining === 1 ? '' : 'es'} to continue.`;
          if (remaining === 0) status.textContent = 'Your hydration bundle is ready.';
        }
      }
      async submit() {
        const button = this.querySelector('[data-submit]');
        const status = this.querySelector('[data-status]');
        const sellingPlan = this.dataset.sellingPlan;
        const delivery = this.querySelector('[data-delivery].is-active')?.textContent?.trim() || '';
        const items = [...this.querySelectorAll('.dnh-flavor')].map((card) => {
          const quantity = Number(card.querySelector('output').textContent);
          const item = {
            id: Number(card.dataset.variantId),
            quantity,
            properties: {
              '_bundle': 'Electrolytes builder',
              'Delivery': delivery,
              'Purchase type': this.purchase === 'subscription' && sellingPlan ? 'Subscribe and save' : 'One time'
            }
          };
          if (this.purchase === 'subscription' && sellingPlan) item.selling_plan = Number(sellingPlan);
          return item;
        }).filter((item) => item.quantity > 0);
        if (!items.length || this.selectedCount() !== this.targetCount) return;
        button.disabled = true;
        if (status) status.textContent = 'Adding your flavors...';
        try {
          const response = await fetch(this.dataset.cartUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items }) });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.href = '/checkout';
        } catch (error) {
          if (status) status.textContent = 'Something went wrong. Please try again.';
          button.disabled = false;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["electrolytes-large-reviews"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-large-reviews]').forEach((section) => {
    if (section.dataset.ready) return;
    section.dataset.ready = 'true';
    const track = section.querySelector('.dnh-large-reviews__track');
    const slides = [...section.querySelectorAll('.dnh-large-reviews__slide')];
    const dots = [...section.querySelectorAll('.dnh-large-reviews__dots button')];
    if (!track || !slides.length) return;
    let index = 0;
    const go = (next) => {
      index = (next + slides.length) % slides.length;
      track.style.transform = `translateX(-${index * 100}%)`;
      slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === index));
      dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
    };
    dots.forEach((dot, dotIndex) => dot.addEventListener('click', () => go(dotIndex)));
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setInterval(() => go(index + 1), 4200);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["electrolytes-product-main"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.dnh-product-hero').forEach((section) => {
    const image = section.querySelector('.dnh-product-hero__image');
    section.querySelectorAll('[data-dnh-product-thumb]').forEach((button) => {
      button.addEventListener('click', () => {
        if (image) {
          image.src = button.dataset.image;
          image.alt = button.dataset.alt;
        }
        section.querySelectorAll('[data-dnh-product-thumb]').forEach((thumb) => thumb.classList.toggle('is-active', thumb === button));
      });
    });
    section.querySelectorAll('[data-dnh-purchase-option]').forEach((button) => {
      button.addEventListener('click', () => {
        section.querySelectorAll('[data-dnh-purchase-option]').forEach((option) => {
          const active = option === button;
          option.classList.toggle('is-active', active);
          option.setAttribute('aria-checked', active ? 'true' : 'false');
        });
      });
    });
    section.querySelector('[data-dnh-open-flavors]')?.addEventListener('click', () => {
      window.dispatchEvent(new CustomEvent('dnh:open-flavors'));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["electrolytes-video-text-reviews"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-video-text-reviews]').forEach((section) => {
    if (section.dataset.ready) return;
    section.dataset.ready = 'true';
    const tabs = [...section.querySelectorAll('[data-vtr-tab]')];
    const panels = [...section.querySelectorAll('[data-vtr-panel]')];
    const pauseVideos = () => {
      section.querySelectorAll('video').forEach((video) => {
        video.pause();
        video.closest('.dnh-video-text-reviews__card')?.querySelector('.dnh-video-text-reviews__play')?.classList.remove('is-playing');
      });
    };
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.vtrTab;
        tabs.forEach((item) => {
          const active = item === tab;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach((panel) => panel.classList.toggle('is-active', panel.dataset.vtrPanel === target));
        pauseVideos();
      });
    });
    section.querySelectorAll('.dnh-video-text-reviews__play').forEach((button) => {
      button.addEventListener('click', async () => {
        const video = button.closest('.dnh-video-text-reviews__card')?.querySelector('video');
        if (!video) return;
        if (video.paused) {
          pauseVideos();
          await video.play();
          button.classList.add('is-playing');
        } else {
          video.pause();
          button.classList.remove('is-playing');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
